import { linkToContactUs, linkToSupport } from "helpers/links-builders/helpCenter";
import { linkToPrivacyPolicy } from "helpers/links-builders/PrivacyPolicy";
import { linkToSafetyTips } from "helpers/links-builders/safetyTips";
import { linkToTermOfUse } from "helpers/links-builders/termOfUse";
import React from "react";
import { useTheme } from "styled-components";
import HeadingAndLinks from "./headingAndLinks";
import {linkSalesRepresentativesIndex} from "helpers/links-builders/sales-representatives-links";

const Help = () => {
  const { translations } = useTheme();
  return (
    <HeadingAndLinks
      parentComponent={"Help"}
      isMultiCol={false}
      headerText={translations.help}
      LinksData={[
        {
          linkText: translations.contactUs,
          linkUrl: linkToContactUs(),
        },
        {
          linkText: translations.footer.sales,
          linkUrl: linkSalesRepresentativesIndex(),
        },
        {
          linkText: translations.footer.tos,
          linkUrl: linkToTermOfUse(),
        },
        {
          linkText: translations.footer.privacyPolicy,
          linkUrl: linkToPrivacyPolicy(),
        },
        {
          linkText: translations.footer.safetyTips,
          linkUrl: linkToSafetyTips(),
        },
      ]}
    />
  );
};

export default Help;
